import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { AlertService } from '../_services/alert.service';
import { environment } from '../../environments/environment'
import { AprovadorSLD, IAprovadorSLDResponse } from '../_models/AprovadorSLD';
import { tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class AprovadorSLDService {

    ObterAprovadores(): Observable<any> {
        let apiURL = `${environment.apiUrl}/api/usuario/aprovadores`
        return this.http.get<AprovadorSLD[]>(apiURL);
    }

    filtrar(filtro: { nome: string } = { nome: '' }, page = 1): Observable<IAprovadorSLDResponse> {
        let apiURL = `${environment.apiUrl}/api/usuario/aprovadores`
        return this.http.get<IAprovadorSLDResponse>(apiURL)
            .pipe(
                tap((response: IAprovadorSLDResponse) => {
                    console.log(response);
                    response.data = response.data
                        .map(aprovador => new AprovadorSLD(aprovador.login, aprovador.nome))
                        .filter(aprovador => aprovador.nome.includes(filtro.nome))
                    return response;
                }))
    }

    constructor(private http: HttpClient,
        private alertService: AlertService) { }


    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            console.error(error); // log to console instead
            console.log(`${operation} failed: ${error.message}`);

            this.alertService.error(`Ocorreu um erro ao buscar as divisões. Detalhes: \n ${operation} failed: ${error.message}`);
            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

}
